export const googleAuthClientID = () => {
    // Map the hostnames to their corresponding GOOGLE_CLIENT_IDs
    const hostDomainMap = {
      "dev-vendors.intermesh.net": "64436141311-5vl48panuf3ab3d90im1edaetsv6hff4.apps.googleusercontent.com",
      "beta-vendors.intermesh.net": "119752410235-o3gmbgecp8gvnrh7q3h792q00mgo3qfp.apps.googleusercontent.com",
      "vendors.intermesh.net": "64436141311-b7ck1mq6id6fj5ck6ae6n6n0dongk0nt.apps.googleusercontent.com",
    };

    const clientId = hostDomainMap[window.location.hostname];

    if (!clientId) {
        console.log(`Google Client ID not found for host: ${window.location.hostname}`);
    }
      
    return [clientId, window.location.origin];
};